'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = JointLoginReducer;

var _JointLoginActions = require('../actions/JointLoginActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    accessToken: null,
    accessTokens: {},
    user: null,
    isLoggingIn: true,
    error: null,
    facebookAvailability: {
        isChecking: true,
        isAvailable: true
    },
    isFastCheckoutEnabled: true
};

function JointLoginReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _JointLoginActions.types.SET_ACCESS_TOKEN:
            return (0, _extends4.default)({}, state, {
                accessToken: action.payload.accessToken
            });

        case _JointLoginActions.types.LOGIN_REQUEST:
            return (0, _extends4.default)({}, state, {
                isLoggingIn: true,
                error: null
            });

        case _JointLoginActions.types.LOGIN_SUCCESS:
        case _JointLoginActions.types.HARD_LOGIN_SUCCESS:
            var newState = (0, _extends4.default)({}, state, {
                accessTokens: (0, _extends4.default)({}, state.accessTokens, (0, _defineProperty3.default)({}, action.payload.user.ns, {
                    accessToken: action.payload.accessToken,
                    origAccessToken: action.payload.origAccessToken,
                    user: action.payload.user
                })),
                isLoggingIn: false,
                error: null
            });

            newState.isConnectedToFacebook = newState.isConnectedToFacebook || action.payload.user.ns === 'com.facebook' || action.payload.user.ns === 'com.openrest';

            if (action.payload.user.ns === 'com.wix') {
                newState.accessToken = action.payload.accessToken;
                newState.user = action.payload.user;
            }

            if (action.payload.user.ns === 'com.openrest' && !state.accessToken) {
                newState.accessToken = action.payload.accessToken;
                newState.user = action.payload.user;
            }

            return newState;

        case _JointLoginActions.types.LOGIN_FAILURE:
        case _JointLoginActions.types.HARD_LOGIN_FAILURE:
            return (0, _extends4.default)({}, state, {
                isLoggingIn: false,
                error: action.error
            });

        case _JointLoginActions.types.SET_FACEBOOK_AVAILABILITY:
            return (0, _extends4.default)({}, state, {
                facebookAvailability: {
                    isChecking: false,
                    isAvailable: action.payload
                }
            });

        case _JointLoginActions.types.SET_USING_FORCE_ACCESS_TOKEN:
            return (0, _extends4.default)({}, state, {
                usingForceAccessToken: action.payload
            });

        case _JointLoginActions.types.SET_FAST_CHECKOUT_ENABLED:
            return (0, _extends4.default)({}, state, {
                isFastCheckoutEnabled: action.payload
            });

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/reducers/JointLoginReducer.js
// module id = 854
// module chunks = 0